// Presseartikel für die Startseite.
// Bilder liegen in public/presse/ — der Pfad ist relativ zum deploy-root.
// Neue Einträge einfach am Anfang der Liste einfügen, dann erscheinen sie zuerst.
//
// Felder:
//   src  (pflicht)   Pfad zum Bild, relativ zum public-Ordner
//   text (optional)  Artikeltext; ohne Text wird nur das Bild gezeigt
//   link (optional)  URL — wenn gesetzt, wird die ganze Karte klickbar (öffnet in neuem Tab)

export default [
    {
        src: "presse/Artikel7.jpg",
        text: `Am 31. Mai 2026 fand der erste Kampftag des Bezirksmannschaftspokal für gemischte Mannschaften des Bezirks Hannover 2026 statt.
                An diesem Bezirksmannschaftspokal nimmt eine Kampfgemeinschaft vom Hochschulsport und SC Budokwai Garbsen gemeinsam teil.
                Zwei der drei Begegnungen konnte die Kampfgemeinschaft klar für sich verbuchen – die dritte Begegnung konnte die Gegnerische Mannschaft sehr knapp für sich entscheiden.
                Der zweite Kampftag findet am Sonntag, den 28. Juni 2026 in der Schulsporthalle, Sehlder Straße 20, 31008 Elze statt.
                Termin jetzt schon vormerken!   `,
    },
     {
        src: "presse/Artikel6.jpg",
        text: `Am 30. Mai 2026 fanden sowohl der Kids Cup sowie die Bezirkseinzelmeisterschaft der U15 statt. Unsere Athleten zeigten großen Einsatz und sammelten wertvolle Wettkampferfahrung.
        Beim Kids Cup konnte sich Yamen mit einer starken Leistung die Bronzemedaille sichern. Jannis erreichte einen guten fünften Platz und verpasste das Podium nur knapp. Adam zeigte eine starke Leistung und konnte einen Kampf mit einem Haltegriff für sich entscheiden.
        Unsere Teilnehmer sind stolz auf ihre erbrachten Leistungen.
        Auch die Eltern und Trainer sind stolz! 
        Herzlichen Glückwunsch an Adam, Jannis und Yamen!`,
     },
    {
        src: "presse/artikel5.jpg",
        text: `Am 16. Mai 2026 nahm Wiebke Dageförde am Tiger-Cup beim Rot-Weiß Visbeck -63 kg teil. Es war ein gut besuchtes Turnier mit etlichen guten Judoka. In der erste Runde musste sich Wiebke direkt der späteren Goldgewinnerin Maaike Hoogreveen (Judoteam Groningen) stellen und musste sich leider geschlagen geben. In der Begegnung gegen Nicole Schlej (VfL Stade) führte eine Unachtsamkeit - aus Rücksicht auf das eigene Knie - zum Sieg der Kontrahentin. Dadurch blieb der Weg in der Trostrunde zu Bronze leider verwehrt. Wiebke war nach einer zwei jährigen Kampfpause aufgrund einer schwierigen Knieverletzung jedoch froh wieder auf der Matte gestanden zu haben. "Ich habe mein persönliches Ziel, wieder auf der Matte zu stehen und sicher zu sein, dass mein Knie hält, erreicht." merkte sie im Nachgang zum Turnier an. `,
    },
    {
        src: "presse/artikel1.jpeg",
        text: `Am 25.01.2026 fanden in Braunschweig die Landesmeisterschaften der U21 statt. Nach mehreren Jahren Abstinenz konnten auch wieder zwei Sportler unseres Vereins teilnehmen. Arssen Haumann belegte dabei den ersten Platz in der Gewichtsklasse -90 kg. Wladislaw Solovev belegte den dritten Platz in der Gewichtsklasse bis 81 kg.`,
    },
    {
        src: "presse/artikel2.jpeg",
        text: `Arssen Haumann (-90 kg) belegte den dritten Platz bei der Norddeutschen Meisterschaft der U21. Damit qualifizierte er sich für die Deutsche Meisterschaft.

Auch Wladislaw Solovev (-81) nahm teil, belegte den sechsten Platz und verpasste dadurch knapp die Qualifikation zur Deutschen Meisterschaft.`,
    },
    {
        src: "presse/artikel3.jpeg",
        text: `Erfolgreiche Gürtelprüfungen für unsere Jüngsten!

Vor den Frühlingsferien fand unsere nächste Gürtelprüfung statt. 12 unserer Kinder haben bestanden und können nun endlich den farbigen Gurt tragen.

Wir wünschen allen schöne Frühlingsferien und frohe Ostern!`,
    },
];
